export const messages: any = {
  after(n: string, e: any[]) {
    return 'השדה ' + n + ' חייב להכיל תאריך לאחר ' + e[0];
  }, alpha_dash(n: string) {
    return 'השדה ' + n + ' יכול להכיל רק אותיות, מספרים ומקפים';
  }, alpha_num(n: string) {
    return 'השדה ' + n + ' יכול להכיל רק אותיות ומספרים';
  }, alpha_spaces(n: string) {
    return 'השדה ' + n + ' יכול להכיל רק אותיות ורווחים';
  }, alpha(n: string) {
    return 'השדה ' + n + ' יכול להכיל רק אותיות';
  }, before(n: string, e: any[]) {
    return 'השדה ' + n + ' חייב להכיל תאריך לפני ' + e[0];
  }, between(n: string, e: any[]) {
    return 'הערך ' + n + ' חייב להיות בין ' + e[0] + ' ל- ' + e[1];
  }, confirmed(n: string) {
    return 'הערכים של ' + n + ' חייבים להיות זהים';
  }, date_between(n: string, e: any[]) {
    return 'השדה ' + n + ' חייב להיות בין התאריכים ' + e[0] + ' ו- ' + e[1];
  }, date_format(n: string, e: any[]) {
    return 'השדה ' + n + ' חייב להיות בפורמט ' + e[0];
  }, decimal(n: string, e: any[]) {
    let t = e[0];
    return void 0 === t && (t = '*'), 'השדה ' + n + ' חייב להיות מספרי ולהכיל ' +
    ('*' === t ? '' : t) + ' נקודות עשרוניות';
  }, digits(n: string, e: any[]) {
    return 'השדה ' + n + ' חייב להיות מספר ולהכיל ' + e[0] + ' ספרות בדיוק';
  }, dimensions(n: string, e: any[]) {
    return 'השדה ' + n + ' חייב להיות ' + e[0] + ' פיקסלים על ' + e[1] + ' פיקסלים';
  }, email(n: string) {
    return 'השדה ' + n + ' חייב להכיל כתובת אימייל תקינה';
  }, ext(n: string) {
    return 'השדה ' + n + ' חייב להכיל קובץ תקין';
  }, image(n: string) {
    return 'השדה ' + n + ' חייב להכיל תמונה';
  }, in(n: string) {
    return 'השדה ' + n + ' חייב להיות בעל ערך תקין';
  }, ip(n: string) {
    return 'השדה ' + n + ' חייב להכיל כתובת IP תקינה';
  }, max(n: string, e: any[]) {
    return 'השדה ' + n + ' לא יכול להכיל יותר מ- ' + e[0] + ' תווים';
  }, max_value(n: string, e: any[]) {
    return 'השדה ' + n + ' יכול להיות ' + e[0] + ' לכל היותר';
  }, mimes() {
    return 'הקובץ חייב להיות מסוג תקין';
  }, min(n: string, e: any[]) {
    return 'השדה ' + n + ' חייב להכיל ' + e[0] + ' תווים לפחות';
  }, min_value(n: string, e: any[]) {
    return 'הערך של ' + n + ' חייב להיות לפחות ' + e[0];
  }, not_in(n: string) {
    return 'השדה ' + n + ' חייב להכיל ערך תקין';
  }, numeric(n: string) {
    return 'השדה ' + n + ' יכול להכיל ספרות בלבד';
  }, regex(n: string) {
    return 'הפורמט של ' + n + ' אינו תקין';
  }, required(n: string, e: any[]) {
    return 'השדה ' + n + ' הינו שדה חובה';
  }, size(n: string, e: number[]) {
    let t: number = e[0];
    const r: number = 1024;
    t = Number(t) * r;
    const u: number = 0 === (t) ? 0 : Math.floor(Math.log(t) / Math.log(r));
    const i: number = (t / Math.pow(r, u));
    return 'השדה ' + n + ' חייב לשקול פחות מ '
      + (i.toFixed(2)
        + ' ' + ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][u]);
  }, url(n: string) {
    return n + ' אינו מכיל כתובת אינטרנט תקינה';
  }
};
